<template>
  <div style="width: 105%;  margin-left: -5%; height: 100%; margin-top: 20px; ">
    <p id="title" style="font-size: 18px; font-family: 黑体; font-weight: bold; color: white; margin-left: 0;">待维修列表</p>
    <div id="SubLeftThreeHeader" style="width: 97%; height: 24px; margin-left: 0; margin-top: 10px;">
      <table>
        <thead>
        <tr style="font-size: 15px;">
          <th>报警站点</th>
          <th>报修人</th>
          <th>联系方式</th>
          <th>巡检时间</th>
          <!--<th>备注</th>-->
        </tr>
        </thead>
      </table>
    </div>
    <div id="SubLeftThreeContent" style="width: 97%; height: 160px;margin-left: 0; overflow-y: scroll; background-color: #26374b;">
      <table>
        <tbody>
        <tr v-for="item in tableData">
          <th>{{item.pointName}}</th>
          <th>{{item.reporterName}}</th>
          <th>{{item.phoneNumber}}</th>
          <th>{{item.reportTime}}</th>
          <!--<th >{{item.reportContent}}</th>-->
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubLeftThree',
  props: ['areaId'],
  data(){
    return {
      AreaBreakSta:{
        "version": 1,
        "method": "synthScreen.AreaBreakSta",
        "params": {
          "areaId":"0",
        },
        "token": "#",
        "id": 0
      },
      tableData:[],
      interval: null, // 轮询
    }
  },
  methods:{
    getAreaBreakSta(){
      this.AreaBreakSta.token = this.$store.state.token;
      this.AreaBreakSta.params.areaId = this.areaId;
      console.log('获取各区维修/报修表');
      console.log(this.AreaBreakSta);
      this.$axios.post(this.$newMainUrl, this.AreaBreakSta).then(res=> {
        // this.$message({
        //   type:'success',
        //   message: '刷新'
        // })
        console.log('获取各区维修/报修表请求得到响应');
        console.log(res.data);
        if(res.data.hasOwnProperty('result')){
          this.tableData = res.data.result.repoStatus;
        }else{
          this.$message({
            type:'error',
            message:'获取警报点静态信息失败，' + res.data.error.message
          })
        }
      })
    }

  },
  mounted(){
    this.getAreaBreakSta();
    this.interval = setInterval(()=>{
      this.getAreaBreakSta();
    }, 3000);
  },
  destroyed(){
    clearInterval(this.interval);
    // this.$message({
    //   type:'error',
    //   message: '结束'
    // })
  }
}
</script>

<style scoped lang="scss">
  #SubLeftThreeHeader, #SubLeftThreeContent{
    table{
      color: white;
      font-size: 13px;
      font-family: 黑体;
      transform: scale(1.0);
      width: 100%;
      border-collapse: collapse;
      colgroup{
        col:nth-child(1){
          width: 30px;
        }
        col:nth-child(2){
          width: 20px;
        }
      }
      tr{
        background-color: #26374b;
        line-height: 30px;
        height: 30px;
        th:nth-child(1), td:nth-child(1){
          width: 7em;
        }
        th:nth-child(2), td:nth-child(2){
          width: 5em;
        }
        th:nth-child(3), td:nth-child(3){
          width: 5em;
        }
        th:nth-child(4), td:nth-child(4){
          width: 10em;
        }
        /*th:nth-child(5), td:nth-child(5){*/
          /*width: 5em;*/
        /*}*/
      }
    };
  }
  #SubLeftThreeHeader tr:first-child{
    background-color: #213380;
  }
</style>
<style>
  #SubLeftThreeContent::-webkit-scrollbar{
    display: none;
  }
  #SubLeftThreeContent{
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
</style>
